import React, { useState } from 'react';
import { API_BASE_URL } from '../config';
import '../styles/AdminPanel.css';

const AdminProtected = ({ children }) => {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem('adminKey')
  );
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await fetch(`${API_BASE_URL}/api/admin-verify`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: password })
      });
      const data = await res.json();

      if (data.success) {
        localStorage.setItem('adminKey', password);
        setIsAuthenticated(true);
      } else {
        setError('Invalid password');
        setPassword('');
      }
    } catch (err) {
      setError('Could not reach server');
    } finally {
      setLoading(false);
    }
  };

  if (isAuthenticated) {
    return children;
  }

  return (
    <div className="admin-login">
      <div className="admin-login-container">
        <h1>Admin Access</h1>
        <p>Enter the admin password to continue</p>

        {error && <div className="admin-error">{error}</div>}

        <form onSubmit={handleLogin}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Admin password"
            className="admin-password-input"
          />
          <button type="submit" className="admin-login-button" disabled={loading}>
            {loading ? 'Verifying...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminProtected;
